import { createContext } from "react";

import ModalState from "./ModalState";

export interface ModalsContextValue {
  collapse: (id: string) => void;
  destroy: (id: string) => void;
  initialize: () => string;
  minimize: (id: string) => void;
  modals: ModalState[];
  restore: (id: string) => void;
}

const ModalsContext = createContext<ModalsContextValue | null>(null);

ModalsContext.displayName = "ModalsContext";

export default ModalsContext;
